import { useEffect, useState } from 'react';
import { BeaconLoader } from '@/components/BeaconLoader';

const REVEAL_DELAY_MS = 250;

function useDelayedReveal(delayMs = REVEAL_DELAY_MS) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), delayMs);

    return () => clearTimeout(timer);
  }, [delayMs]);

  return visible;
}

export function FullPageLoader() {
  const visible = useDelayedReveal();

  if (!visible) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center">
      <BeaconLoader size={32} />
    </div>
  );
}

export function LoadingState() {
  const visible = useDelayedReveal();

  if (!visible) return null;

  return (
    <div className="flex min-h-[50vh] w-full items-center justify-center">
      <BeaconLoader size={32} />
    </div>
  );
}
